export const GET_FUND_DETAIL = "FUND@GET_FUND_DETAIL";
export const GET_FUND_DETAIL_INIT = "FUND@GET_FUND_DETAIL_INIT";
export const GET_FUND_DETAIL_SUCCESS = "FUND@GET_FUND_DETAIL_SUCCESS";
export const GET_FUND_DETAIL_FAILED = "FUND@GET_FUND_DETAIL_FAILED";

export const GET_FUNDS= "FUND@GET_FUNDS";
export const GET_FUNDS_INIT = "FUND@GET_FUNDS_INIT";
export const GET_FUNDS_SUCCESS = "FUND@GET_FUNDS_SUCCESS";
export const GET_FUNDS_FAILED = "FUND@GET_FUNDS_FAILED";